import {
  useInviteUserToWorkspaceApi,
  useRemoveUserFromWorkspaceApi,
} from '@/api/settings';

export const useInviteUserToWorkspaceService = () => {
  const inviteUserMutation = useInviteUserToWorkspaceApi();

  return {
    inviteUserToWorkspace: inviteUserMutation.mutate,
    isLoading: inviteUserMutation.isPending,
    error: inviteUserMutation.error,
  };
};

export const useRemoveUserFromWorkspaceService = () => {
  const mutation = useRemoveUserFromWorkspaceApi();

  return {
    removeUser: mutation.mutate,
    isRemoving: mutation.isPending,
  };
};
